import { AxiosInstance } from "axios";

import {
  Agent,
  AgentKnowledgeBase,
  AgentSettingsVersion,
  AssignKnowledgeBasesInput,
  CreateAgentInput,
  CreateSettingsVersionInput,
  RemoveKnowledgeBasesInput,
  UpdateAgentInput,
} from "./types";

export const createAgent = async (
  agent: CreateAgentInput,
  axiosInstance: AxiosInstance,
): Promise<Agent> => {
  return (await axiosInstance.post<Agent>(`/agent/`, agent)).data;
};

export const getAgents = async (
  axiosInstance: AxiosInstance,
  signal?: AbortSignal,
): Promise<Agent[]> => {
  return (await axiosInstance.get<Agent[]>(`/agent/`, { signal })).data;
};

export const getAgent = async (
  agentId: string,
  axiosInstance: AxiosInstance,
): Promise<Agent> => {
  return (await axiosInstance.get<Agent>(`/agent/${agentId}`)).data;
};

export const updateAgent = async (
  agentId: string,
  agent: UpdateAgentInput,
  axiosInstance: AxiosInstance,
): Promise<Agent> => {
  return (await axiosInstance.put<Agent>(`/agent/${agentId}`, agent)).data;
};

export const deleteAgent = async (
  agentId: string,
  axiosInstance: AxiosInstance,
): Promise<void> => {
  await axiosInstance.delete(`/agent/${agentId}`);
};

export const assignKnowledgeBases = async (
  agentId: string,
  data: AssignKnowledgeBasesInput,
  axiosInstance: AxiosInstance,
): Promise<void> => {
  await axiosInstance.post(`/agent/${agentId}/knowledge-bases`, data);
};

export const removeKnowledgeBases = async (
  agentId: string,
  data: RemoveKnowledgeBasesInput,
  axiosInstance: AxiosInstance,
): Promise<void> => {
  await axiosInstance.delete(`/agent/${agentId}/knowledge-bases`, { data });
};

export const getAgentKnowledgeBases = async (
  agentId: string,
  axiosInstance: AxiosInstance,
): Promise<AgentKnowledgeBase[]> => {
  const response = await axiosInstance.get<AgentKnowledgeBase[]>(
    `/agent/${agentId}/knowledge-bases`,
  );

  return response.data;
};

export const listAgentLlmOptions = async (
  axiosInstance: AxiosInstance,
): Promise<string[]> => {
  return (await axiosInstance.get<string[]>(`/agent/llm-options`)).data;
};

export const listSettingsVersions = async (
  agentId: string,
  axiosInstance: AxiosInstance,
): Promise<AgentSettingsVersion[]> => {
  return (
    await axiosInstance.get<AgentSettingsVersion[]>(
      `/agent/${agentId}/settings-versions`,
    )
  ).data;
};

export const getSettingsVersion = async (
  agentId: string,
  versionId: string,
  axiosInstance: AxiosInstance,
): Promise<AgentSettingsVersion> => {
  return (
    await axiosInstance.get<AgentSettingsVersion>(
      `/agent/${agentId}/settings-versions/${versionId}`,
    )
  ).data;
};

export const createSettingsVersion = async (
  agentId: string,
  input: CreateSettingsVersionInput,
  axiosInstance: AxiosInstance,
): Promise<AgentSettingsVersion> => {
  return (
    await axiosInstance.post<AgentSettingsVersion>(
      `/agent/${agentId}/settings-versions`,
      input,
    )
  ).data;
};

